// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__2-P3n","icon":"SortAdornment_icon__A5AyK","up":"SortAdornment_up__2b6AY","down":"SortAdornment_down__P0tKf","active":"SortAdornment_active__2_1u_"};